import Reveal from '../components/Reveal';

const stats = [
  { number: '100,000+', label: 'Words Solved' },
  { number: '10,000',     label: 'Hand-Crafted Levels' },
  { number: '2,250+',  label: 'Dictionary Words' },
  { number: '7',       label: 'Unlockable Themes' },
];

export default function SocialProof() {
  return (
    <div className="social-bg" id="leaderboard">
      <div className="social-inner">
        <Reveal>
          <div>
            <p className="section-label">Join the Community</p>
            <h2 className="section-title">Players Around the World</h2>
            <p style={{ fontSize: 17, color: 'rgba(255,255,255,0.8)', lineHeight: 1.65 }}>
              Thousands of word lovers challenge themselves every day. Where do you rank?
            </p>
            <div className="stats-grid">
              {stats.map((s) => (
                <div key={s.label} className="stat-card">
                  <span className="stat-number">{s.number}</span>
                  <span className="stat-label">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
        <Reveal delay={150}>
          <div className="social-mascot">
            <img src="/assets/mascot/mascot-love.svg" alt="Love mascot" />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
